var path = '/client/front-office/modules/error-pages/views/404.html';
var html = "<react-element react-component=\"ErrorPage\" react-replace=\"true\" code=\"404\" should-show-action=\"true\"/>";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;